export default __webpack_public_path__ + "static/media/proximanova-light-webfont.0b132319.woff";